export function agruparPalletsPorProducto(pallets) {
    const grouped = {};

    pallets.forEach(function (item) {
        const productoId = item.producto_terminado_id || -1;

        if (!grouped[productoId]) {
            grouped[productoId] = {
                id: productoId,
                nombre: item.producto_terminado_nombre || "Sin producto",
                padreNombre: item.producto_terminado_padre_nombre || null,
                subtotalKg: 0,
                pallets: [],
            };
        }

        grouped[productoId].subtotalKg += parseFloat(item.total_peso || 0);

        grouped[productoId].pallets.push(item);
    });

    const productosOrdenados = Object.values(grouped).sort(function (a, b) {
        return a.nombre.localeCompare(b.nombre);
    });

    return productosOrdenados;
}
